import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Txn_Invoice } from '../models/Txn_Invoice';

@Injectable()

export class InvoiceService {
    private readonly InvoiceEndpoint = '/api';
    constructor(private http: HttpClient) { }


    getpendingInvoices(invoicedAcc: string) {
        return this.http.get(this.InvoiceEndpoint + '/Txn_Invoice/getPendingInvoices?invoicedAcc=' + invoicedAcc  );
    }

  getInvoices(invoicedAcc: string, clear_status: string, expiry_status: string, fromDate: string, toDate: string, semester: number, st_department: string, branchId: number, userId:string)
    {
    console.log(`stAcc: ${invoicedAcc} paymentStat: ${clear_status} expiryStat: ${expiry_status} semester: ${semester}  fromDate: ${fromDate} toDate:${toDate} department: ${st_department}`);
    return this.http.get(this.InvoiceEndpoint + '/Txn_Invoice/getInvoices?invoicedAcc=' + invoicedAcc + "&clear_status=" + clear_status + "&expiry_status=" + expiry_status + "&fromDate=" + fromDate + "&toDate=" + toDate + "&semester=" + semester + "&department=" + st_department + "&branchId=" + branchId + "&userId=" + userId );        
  }

  getInvoiceRemain(invoicedAcc: string, st_department: string, semester: number, year: number, season: number, gendarId: number, branchId: number, isPaidFee: number) {
    return this.http.get(this.InvoiceEndpoint + '/Txn_Invoice/getInvoiceRemain?invoicedAcc=' + invoicedAcc + "&department=" + st_department + "&semester=" + semester + "&year=" + year + "&season=" + season + "&gendarId=" + gendarId + "&branchId=" + branchId + "&isPaidFee=" + isPaidFee);
  }

  getStudentDiscount(invoicedAcc: string, clear_status: string, expiry_status: string, fromDate: string, toDate: string, semester: number, st_department: string) {
    console.log(`stAcc: ${invoicedAcc} paymentStat: ${clear_status} expiryStat: ${expiry_status} semester: ${semester}  fromDate: ${fromDate} toDate:${toDate} department: ${st_department}`);
    return this.http.get(this.InvoiceEndpoint + '/Txn_Invoice/getInvoices?invoicedAcc=' + invoicedAcc + "&clear_status=" + clear_status + "&expiry_status=" + expiry_status + "&fromDate=" + fromDate + "&toDate=" + toDate + "&semester=" + semester + "&department=" + st_department);
  }

  getInvoice(inv_no: string) {
    return this.http.get(this.InvoiceEndpoint + '/Txn_Invoice/getInvoice?inv_no=' + inv_no);
  }
  getInvoiceR(inv_no: string) {
    return this.http.get(this.InvoiceEndpoint + '/Txn_Invoice/getInvoiceR?inv_no=' + inv_no);
  }

  deleteInvoices(trn_ref_issue: string, relatedAccount: string, inv_no: number)
  {
      console.log(`stAcc: ${relatedAccount} inv_no: ${inv_no} trn_ref_issue: ${trn_ref_issue} `);
      return this.http.delete(this.InvoiceEndpoint + '/Txn_Invoice/deleteInvoice?inv_no=' + inv_no + "&invoicedAcc=" + relatedAccount + "&trn_ref_no=" + trn_ref_issue + "&username=test");
  }

    reverseInvoices(trn_ref_issue: string, relatedAccount:string , inv_no:number)
    {
        console.log(`stAcc: ${relatedAccount} inv_no: ${inv_no} trn_ref_issue: ${trn_ref_issue} `);
        return this.http.delete(this.InvoiceEndpoint + '/Txn_Invoice/reverseInvoice?inv_no=' + inv_no + "&invoicedAcc=" + relatedAccount + "&trn_ref_no=" + trn_ref_issue + "&username=test");
  }
  updateInvoice(inv: Txn_Invoice) {
    console.log('inside the inv update');
    console.log(inv);
   return this.http.post(this.InvoiceEndpoint + '/Txn_Invoice/updateInvoice/', inv);

  }
  getInvoiceTypes()
  {
    return this.http.get(this.InvoiceEndpoint + '/Txn_Invoice/getInvoiceTypes');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/Acc_InvoiceService.ts